import { Link } from "react-router-dom";
import { Layout } from "../components/layout.tsx";

const SECTIONS = [
  { to: "/admin/orgs", label: "Organizations", desc: "Manage orgs, members, and invitations" },
  { to: "/admin/api-keys", label: "API Keys", desc: "Create and revoke API keys with permissions" },
  { to: "/admin/webhooks", label: "Webhooks", desc: "Register webhooks and view delivery history" },
  {
    to: "/admin/subscription",
    label: "Subscription",
    desc: "Plan tier, usage quotas, and billing",
  },
  { to: "/admin/plugins", label: "Plugins", desc: "Enable, disable, and manage extensions" },
  { to: "/admin/audit", label: "Audit Center", desc: "Activity logs and compliance reports" },
  {
    to: "/admin/usage",
    label: "Usage Analytics",
    desc: "Token, API call, and storage utilization",
  },
  {
    to: "/admin/system-health",
    label: "System Health",
    desc: "Service status and runtime metrics",
  },
];

export function AdminOverviewPage() {
  return (
    <Layout>
      <div className="space-y-6 p-6">
        <div>
          <h1 className="text-2xl font-bold text-white">Administration</h1>
          <p className="mt-1 text-gray-400">
            AIOS v1.0 — Platform management and enterprise controls
          </p>
        </div>

        <div className="grid grid-cols-1 gap-4 md:grid-cols-2 lg:grid-cols-3">
          {SECTIONS.map((s) => (
            <Link
              key={s.to}
              to={s.to}
              className="block rounded-lg border border-gray-800 bg-gray-900 p-5 transition-colors hover:border-indigo-500"
            >
              <div className="mb-1 font-semibold text-white">{s.label}</div>
              <div className="text-sm text-gray-400">{s.desc}</div>
            </Link>
          ))}
        </div>

        <div className="rounded-lg border border-gray-800 bg-gray-900 p-5">
          <h2 className="mb-2 text-lg font-semibold text-white">AIOS v1.0</h2>
          <p className="text-sm text-gray-400">
            AI Operating System — 10-phase platform build complete. Multi-tenancy, subscription
            management, public API, webhooks, plugin framework, enterprise audit, and autonomous AI
            departments are all live.
          </p>
          <div className="mt-4 grid grid-cols-2 gap-3 text-center text-xs text-gray-500 md:grid-cols-4">
            {["10 Phases", "9 Departments", "100+ Routes", "60+ DB Tables"].map((s) => (
              <div key={s} className="rounded bg-gray-800 p-2 font-medium text-white">
                {s}
              </div>
            ))}
          </div>
        </div>
      </div>
    </Layout>
  );
}
